module.exports = __webpack_public_path__ + "static/img/njMidwk.7fcb38fd.png";